import { AdminPageShell } from "@/components/admin/admin-page-shell";
import { AnnouncementsEditor } from "@/components/admin/announcements-editor";

export function AdminAnnouncements() {
  return (
    <AdminPageShell
      title="Avisos de plataforma"
      description="Mensajes que pueden verse en el panel de profesionales o en la landing pública."
    >
      <AnnouncementsEditor />
    </AdminPageShell>
  );
}
